export const cibBluetoothB = ["32 32","<path d='M18.28 16.251l5.789-6.458-9.124-9.793v12.896l-5.382-5.382-1.963 1.963 6.754 6.775-6.754 6.775 1.963 1.963 5.382-5.382 0.17 12.393 9.284-9.29zM20.834 9.814l-3.124 3.124-0.021-6.268zM17.71 19.565l3.124 3.124-3.145 3.145z'></path>"]


//////////////////
// WEBPACK FOOTER
// ./node_modules/@coreui/icons/js/brand/cib-bluetooth-b.js
// module id = null
// module chunks = 